var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{attrs:{"id":"json-editor"}}),_vm._v(" "),_c('button',{attrs:{"id":"get-result"},on:{"click":_vm.getResult}},[_vm._v("get result")]),_vm._v(" "),_c('div',{attrs:{"id":"result"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dcdd58f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin.vue
// module id = NXsp
// module chunks = 1